import { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import qs from 'qs';
import { post } from '../utils/apiUtilities';

function VerifyAuthenticator({ location, setIsAuthenticated }) {
    const queryString = qs.parse(location.search, { ignoreQueryPrefix: true });
    const returnUrl = queryString.ReturnUrl || queryString.returnUrl;
    const token = queryString.token;
    const username = queryString.username;

    const [code, setCode] = useState('');
    const [rememberDevice, setRememberDevice] = useState(false);
    const [isVerifying, setIsVerifying] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [needsAuthRequestRestarted, setNeedsAuthRequestRestarted] = useState(false);
    const [authRequestRestartUrl, setAuthRequestRestartUrl] = useState('');
    const [authRequestRestartMessage, setAuthRequestRestartMessage] = useState('');

    const verify = async (e) => {
        e.preventDefault();
        setIsVerifying(true);
        setErrorMessage('');

        try {
            const d = await post('account/verifyauthenticator', {
                identifier: token,
                code: code,
                rememberDevice: rememberDevice,
                returnUrl: returnUrl,
                isSetup: false
            });

            // Clear error message if successful
            setErrorMessage('');

            if (d.needsAuthRequestRestarted) {
                setNeedsAuthRequestRestarted(true);
                setAuthRequestRestartUrl(d.redirect);
                setAuthRequestRestartMessage(d.message);
                return;
            }
            else {
                setNeedsAuthRequestRestarted(false);
            }

            setIsAuthenticated(true);
            window.location.href = d.redirect;
        }
        catch (err) {
            setNeedsAuthRequestRestarted(false);
            setIsVerifying(false);

            if (err && err.responseText) {
                try {
                    const j = JSON.parse(err.responseText);
                    setErrorMessage(j.detail || j.message || err.responseText);
                }
                catch {
                    setErrorMessage((err.status === 400 || err.status === 401) ? err.responseText : 'An error occurred while verifying. Please try again.');
                }
            }
        }
        finally {
            setIsVerifying(false);
        }
    };

    return (
        <>
            <Helmet>
                <title>Verify Authenticator | CBRN Network</title>
            </Helmet>
            <div id="layout-shell" className="shell top100">
                <div className="main-content container" id="loginCont" tabIndex="-1">
                    <div className="row">
                        <main>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-md-offset-3 col-lg-offset-3">
                                <form autoComplete="off" className="form-horizontal signin-form" onSubmit={verify}>
                                    {needsAuthRequestRestarted && (
                                        <div className="alert alert-danger">
                                            <p>{authRequestRestartMessage}</p>
                                            <p>Please return to the <a href={authRequestRestartUrl}>login page</a> and restart the authentication process.</p>
                                        </div>
                                    )}

                                    {errorMessage && !needsAuthRequestRestarted && (
                                        <div className="alert alert-danger">
                                            <span dangerouslySetInnerHTML={{ __html: errorMessage }}></span>
                                        </div>
                                    )}

                                    <div className="panel panel-default">
                                        <div className="panel-heading">
                                            <h4><i className="fa fa-shield"></i> Two-Factor Authentication</h4>
                                        </div>
                                        <div className="panel-body">
                                            <div className="bottom10 bigger-120">{username}</div>

                                            <div className="form-group">
                                                <label className="col-xs-12 required-field-indicator">
                                                    Enter the 6-digit code from your authenticator app:
                                                </label>
                                                <div className="col-xs-12">
                                                    <input
                                                        className="form-control input-lg text-center"
                                                        type="text"
                                                        inputMode="numeric"
                                                        pattern="[0-9]*"
                                                        maxLength="6"
                                                        placeholder="000000"
                                                        value={code}
                                                        onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                                                        autoFocus
                                                        disabled={needsAuthRequestRestarted}
                                                        style={{ letterSpacing: '8px', fontSize: '24px' }}
                                                    />
                                                    <small className="text-muted">
                                                        Open your Microsoft Authenticator, Google Authenticator, or similar app to get your verification code.
                                                    </small>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <div className="col-xs-12">
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            checked={rememberDevice}
                                                            onChange={(e) => setRememberDevice(e.target.checked)}
                                                            disabled={needsAuthRequestRestarted}
                                                        />
                                                        &nbsp; Don't ask again for 30 days on this device
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <div className="col-xs-12">
                                                    <button
                                                        id="verifyAuthenticatorButton"
                                                        className="btn btn-success btn-lg btn-block"
                                                        name="button"
                                                        disabled={isVerifying || needsAuthRequestRestarted || code.length !== 6}
                                                        type="submit"
                                                    >
                                                        {isVerifying ? (
                                                            <><i className="fa fa-spinner fa-spin"></i> Verifying...</>
                                                        ) : (
                                                            <><i className="fa fa-check"></i> Verify</>
                                                        )}
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <div className="col-xs-12 text-center">
                                                    <a href="#"
                                                        onClick={(e) => { e.preventDefault(); window.history.back(); }}
                                                        disabled={isVerifying}
                                                    >
                                                        <i className="fa fa-arrow-left"></i> Use a different method
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </main>
                    </div>
                </div>
            </div>
        </>
    );
}

export default withRouter(VerifyAuthenticator);

